import { Switch } from 'antd';
import './index.less';
export default Switch;
